module.exports = __webpack_public_path__ + "static/img/lista-aprobados-TDE-2.188f639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lista-aprobados-TDE-2.jpg
// module id = gsuN
// module chunks = 9